import React, {Component} from 'react';
import Slide from '../Globals/Slide/slide';
import InfiniteCalendar from 'react-infinite-calendar';
import firebase from 'firebase';
import { Eye } from 'react-preloading-component';
import './estiloCambio.css';

class CambioViaje extends Component{
    constructor(props){
        super(props);
        this.state={
            fechaSele:'',
            viajesD:[],
            isLoading:true,
            isLoadingE:true,
            empleSeleS:[],
            empleSeleL:[]
        };
    }

    componentDidMount(){
          this.getEvent(new Date());
    }

    getEvent = (fecha) => {
        let viajesD =[];
        this.setState({viajesD:[],isLoading:true});
        firebase.database().ref().child('Programacion').on('value', snap =>{
            if(snap.val()!== null)
            {
                snap.forEach(element => {
                    let datos =element.val();
                    firebase.database().ref('Programacion/'+element.key+'/frecuencia').once('value').then(snap2 =>{
                        snap2.forEach(element2 => {
                            let fechas = element2.val();
                            let fechaR = new Date(fechas.valor);
                            let fechaS = new Date(fecha);
                            if(fechaR.getTime() === fechaS.getTime()){
                                let empleL = 0;
                                let empleS = 0;
                                firebase.database().ref().child('ProgramacionDia').orderByChild('idH').equalTo(element2.key).once('value').then(snap3 =>{
                                    if(snap3.val()!== undefined)
                                    {
                                        snap3.forEach(element => {
                                            let obje = element.val();
                                            if(obje.tipoV === 'llegada'){
                                                empleL = empleL +1;
                                            }
                                            if(obje.tipoV === 'salida'){
                                                empleS = empleS +1;
                                            }
                                        });

                                        let datoss = {nombV:datos.vuelo, np:snap.key, nh:element2.key, cantL:empleL, cantS:empleS}
                                        this.setState({viajesD:[...this.state.viajesD,datoss]});
                                    }
                                    else{
                                        this.setState({viajesD:[]})
                                    }
                                   
                                })
                            }
                        })
                       
                    })  
                });
                setTimeout(() => {
                    this.setState({isLoading:false})
                }, 500);   
            }
        })

    }

    selecion = (datos) =>{
        if(new Date(this.state.fechaSele).getTime()!==new Date(datos).getTime()){
            this.setState({fechaSele:datos})
            this.getEvent(datos);
        }
     }

     ocultar = (index) =>{
         console.log(index)
         if ( document.getElementById(index).classList.contains('open') ){
            document.getElementById(index+'flecha').classList.toggle('glyphicon-chevron-right');
            document.getElementById(index+'flecha').classList.add('glyphicon-chevron-left');
            document.getElementById(index).classList.toggle('open');
         }
         else{
            document.getElementById(index+'flecha').classList.toggle('glyphicon-chevron-left');
            document.getElementById(index+'flecha').classList.add('glyphicon-chevron-right');
            document.getElementById(index).classList.add('open');
         }
         
     }

     verEmpleados = (vuelo) =>{
         this.setState({empleSeleS:[],empleSeleL:[], isLoadingE:true})
         firebase.database().ref().child('ProgramacionDia').orderByChild('idH').equalTo(vuelo).once('value').then(snap3 =>{
            snap3.forEach(element => {
                let objeEmple = element.val();
                firebase.database().ref('Clientes/'+objeEmple.emple).once('value').then(snap =>{
                    let empleData = snap.val();
                    empleData.hora = objeEmple.hora;
                    if(objeEmple.tipoV === 'salida'){
                        this.setState({empleSeleS:[...this.state.empleSeleS,empleData]});
                    }
                    if(objeEmple.tipoV === 'llegada'){
                        this.setState({empleSeleL:[...this.state.empleSeleL,empleData]});
                    }
                })
            });
            setTimeout(() => {
               this.setState({isLoadingE:false}) 
            }, 1000);
        })
     }

    render(){
        return(
            <div>
                <Slide />
                <div className='borde'>
                    <div className="row">
                        <aside className="col-sm-4">
                            <InfiniteCalendar
                            width={'100%'} height={300}
                            locale={{ locale: require('date-fns/locale/es'), headerFormat: 'dddd, D MMM',
                            weekdays: ["Domingo","Lunes","Martes","Miercoles","Jueves","Viernes","Sabado"],
                            blank: 'Nada seleccionado', todayLabel: { long: 'Ahora', short: 'Ahora' }}} 
                            autoFocus={false} onSelect={this.selecion}/>
                        </aside>
                        <aside  className="col-sm-4">
                            <div className='altura'>
                                <ul className="list-group">
                                {this.state.isLoading===true &&   
                                    <div style={{ height:450}}>
                                        <div  className='centro'>                     
                                            <Eye color="#FF4601" size={20} />
                                        </div>
                                    </div>
                                }
                                {this.state.viajesD.map((datos,index) =>{
                                    return(
                                        <div>
                                                {!this.state.isLoading &&
                                                    <li id={index} className="list-group-item">
                                                        {datos.nombV}
                                                        <span onClick={() => this.ocultar(index)} className="show-menu">
                                                            <span id={index+'flecha'} className="glyphicon glyphicon-chevron-left"></span>
                                                        </span>
                                                        <ul className="list-group-submenu" data-tip="React-tooltip">
                                                            <li className="list-group-submenu-item primary cursor" onClick={() => this.verEmpleados(datos.nh)}><span className="glyphicon glyphicon-eye-open "></span></li>
                                                            <li className="list-group-submenu-item edit cursor"><span className="glyphicon glyphicon-pencil"></span></li>
                                                            <li className="list-group-submenu-item" ><span className="badge badge-primary badge-pill">{datos.cantL}</span></li>
                                                            <li className="list-group-submenu-item info abajo"><span className="glyphicon glyphicon-plane"></span></li>
                                                            <li className="list-group-submenu-item" ><span className="badge badge-primary badge-pill">{datos.cantS}</span></li>
                                                            <li className="list-group-submenu-item info"><span className="glyphicon glyphicon-plane"></span></li>
                                                        </ul>
                                                    </li>
                                                }
                                        </div>
                                        
                                    )
                                })}
                                </ul>
                            </div>
                        </aside>
                        <aside  className="col-sm-4"> 
                            <div className='altura'>
                                <ul className="sidebarservices">
                                {(this.state.isLoadingE === false && this.state.isLoading === false)&& 
                                    <div>
                                        <li className="head">Salida de vuelos</li>
                                            {this.state.empleSeleS.map((datos,index) =>{
                                                return(
                                                    <li>
                                                    <div className="row">
                                                    <aside className="col-sm-6">
                                                        <p className='izquierza'>{datos.nombre + ' ' + datos.apellido}</p>
                                                    </aside>
                                                    <aside className="col-sm-6">
                                                        <p className='izquierza'>{datos.hora}</p>
                                                    </aside>
                                                    </div>
                                                    </li>
                                                )
                                            })}
                                        <li className="head">Llegada de vuelos</li>
                                            {this.state.empleSeleL.map((datos,index) =>{
                                                return(
                                                    <li>
                                                    <div className="row">
                                                    <aside className="col-sm-6">
                                                        <p className='izquierza'>{datos.nombre + ' ' + datos.apellido}</p>
                                                    </aside>
                                                    <aside className="col-sm-6">
                                                        <p className='izquierza'>{datos.hora}</p>
                                                    </aside>
                                                    </div>
                                                    </li>
                                                )
                                            })}
                                    </div>
                                    }
                                </ul>
                                {(this.state.isLoadingE === true && this.state.isLoading === false)&&   
                                        <div style={{ height:450}}>
                                            <div  className='centro'>                     
                                                <Eye color="#FF4601" size={20} />
                                            </div>
                                        </div>
                                }
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
            
        )
    }
}
export default CambioViaje;


// WEBPACK FOOTER //
// ./src/Components/Programacion/cambioViajes.js